import * as React from "react";
import Image from "../atoms/Image";
import Span from "../atoms/Span";
import ToolTip from "../atoms/ToolTip";

export interface IIconProps {
  id: string;
  icon: string;
  text: string;
  style?: React.CSSProperties;
  tooltip?: boolean;
}

const Icon: React.SFC<IIconProps> = (props: IIconProps) => {
    const { icon, id, style, text, tooltip } = props;
    var smallStyle = {
        height: '32px',
        padding: '0px 0px 0px 0px',
        margin: '0px 0px 0px 0px'
    };
  return (
    <React.Fragment>
      <Span id={id}>
              <Image src={icon} alt={text} style={style ? style:smallStyle} />
      </Span>
      {tooltip && (
        <ToolTip target={id}>
          <Span>{text}</Span>
        </ToolTip>
      )}
    </React.Fragment>
  );
};

export default Icon;
